import './styles.scss'
import React, { useState } from 'react'
import { I18n } from 'react-redux-i18n'

import ReactionIcons from 'components/ReactionIcons'
import ModalWrapper from 'components/ModalWrapper'
import { getStaticImage } from 'utils/statics'

const PostDetailCard = ({ avatarSrc, photos, contentText, reactions, postLink, channel, avatarMime }) => {
  const [isOpenPostModal, setIsOpenPostModal] = useState(false)
  const togglePostModal = () => setIsOpenPostModal(!isOpenPostModal)

  return (
    <div className='post-detail-card'>
      <AvatarProfile
        onClick={togglePostModal}
        url={avatarSrc}
        mime={avatarMime}
        videoHeight='60'
        className='post-detail-card__picture'
        videoClassName='post-detail-card__video'
      />

      <div className='post-detail-card__content'>
        <div className='post-detail-card__text'>
          <p dangerouslySetInnerHTML={{ __html: contentText }}></p>
          <button type='button' onClick={togglePostModal}>{I18n.t('text_see_more')}</button>
        </div>
        <ReactionIcons reactions={reactions} />
      </div>

      <ModalWrapper
        isOpen={isOpenPostModal}
        toggle={togglePostModal}
        header='Post'
        body={
          <div className='post-detail-card__modal-content'>
            {photos?.length > 0 ? (
              <div className='post-detail-card__modal-photos-mosaic'>
                {photos.map((photoSrc, index) => index <= 3 && (
                  <a key={index} href={photoSrc} target='_blank' rel='noopener noreferrer'>
                    <figure>
                      <img src={photoSrc} alt='Mosaic' />
                    </figure>
                  </a>
                ))}
              </div>
            ) : (
              <AvatarProfile
                url={avatarSrc}
                mime={avatarMime}
                videoControls
                className='post-detail-card__modal-picture'
              />
            )}
            <p className='post-detail-card__modal-text'>{contentText}</p>
            {
              postLink ? (
                <a href={postLink} className='btn btn-primary' target='_black' role='button'>
                  {I18n.t(`buttons_postLink_${channel}`)}
                </a>
              ) : null
            }
          </div>
        }
      />
    </div>
  )
}

function AvatarProfile(props) {
  const {
    url, className, mime = '', videoHeight = '240', videoControls = false,
    onClick = null, videoClassName = ''
  } = props

  if (mime.includes("video")) {
    return (
      <video
        className={videoClassName}
        height={videoHeight}
        controls={videoControls}
        onClick={onClick ? () => onClick() : null}
      >
        <source src={url} type={mime} />
        {I18n.t('dashboard_video_notSupported')}
      </video>
    )
  }

  return  (
    <figure className={className} onClick={onClick ? () => onClick() : null}>
      <img
        alt='Post'
        src={url || getStaticImage('/default-picture.png')}
        onError={event => {
          event.target.src = getStaticImage('/default-picture.png')
          event.onerror = null
        }}
      />
    </figure>
  )
}

export default PostDetailCard
